import styled from "@emotion/styled";
import {
  ArrowRight,
  Divider,
  Text,
  TextField,
} from "@totalenergiescode/mobility-business-rev-design-system";

export const StyledContainerDiv = styled("div")({
  display: "flex",
  flexDirection: "column",
});

export const StyledTitleText = styled(Text)({
  padding: "24px 0px 24px 34px",
});

export const StyledDivider = styled(Divider)({
  marginInline: "34px",
});

export const StyledIconArrowRight = styled(ArrowRight)(({ theme }) => ({
  color: theme.palette.primary[500],
  width: "26px",
  height: "auto",
}));

export const StyledCellDiv = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "10px",
});

export const StyledCellText = styled(Text)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "10px",
  color: theme.palette.grey[900],
}));

export const StyledSearchFieldContainerDiv = styled("div")({
  width: "60%",
  minWidth: "200px",
  paddingLeft: "24px",
  margin: "14px",
});

export const StyledSearchTextField = styled(TextField)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: "50px 50px 0px 50px",
  "*.MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.grey[200],
    borderRadius: "50px 50px 0px 50px",
    borderWidth: 1,
  },
  "&:focus": {
    borderColor: "#007bff",
    boxShadow: "0 0 0 0.2rem rgba(0, 123, 255, 0.25)",
  },
  ".MuiOutlinedInput-root": {
    paddingLeft: "8px",
  },
  ".MuiInputAdornment-root > div": {
    padding: "8px",
  },
}));

export const StyledRoundedLeftContainerDiv = styled("div")(({ theme }) => ({
  paddingInline: "34px",
  background: `linear-gradient(
    180deg,
    ${theme.palette.grey[100]} 0%,
    ${theme.palette.background.paper} 30%
  )`,
  borderTopLeftRadius: "40px",
}));

export const StyledCurrentCountOnTotalText = styled(Text)(({ theme }) => ({
  color: theme.palette.grey[500],
  textAlign: "center",
}));

export const StyledCurrentCountOnTotalContainerDiv = styled("div")({
  paddingBlock: "14px",
});
